// extracted by mini-css-extract-plugin
export default {"icon_pointer":"LoginForm_icon_pointer__pTa3L"};